import { render } from "./PracticeExamSetupPage.vue?vue&type=template&id=5ee4665c"
import script from "./PracticeExamSetupPage.vue?vue&type=script&lang=js"
export * from "./PracticeExamSetupPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__